import React from "react";
import log from "../utils/log";
import { setInstalled } from "../state/ducks/installPrompt";
import { useDispatch } from "react-redux";

const PromptContext = React.createContext(null);
export default PromptContext;

export function PromptContextComponent({ children }) {
  const [deferredPrompt, _setDeferredPrompt] = React.useState(null);
  const dispatch = useDispatch();

  const setDeferredPrompt = (data) => {
    _setDeferredPrompt(data);
  };

  const handleInstallClick = (deferredPrompt) => {
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        log.info("User accepted the install prompt");
      } else {
        log.info("User dismissed the install prompt");
      }
    });
  };

  window.addEventListener("beforeinstallprompt", (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    setDeferredPrompt(e);
    // // Google analystics
    if (typeof window !== "undefined") {
      window.gtag("event", "addtohome_prompt");
    }
  });

  // Hide install prompt in the app once app has been installed
  window.addEventListener("appinstalled", () => {
    // Clear the deferredPrompt so it can be garbage collected
    setDeferredPrompt(null);
    // Set redux state installed to true to hide prompt from showing
    dispatch(setInstalled());
    // Optionally, send analytics event to indicate successful install
    if (typeof window !== "undefined") {
      window.gtag("event", "addtohome_installed");
    }
    log.info("PWA was installed");
  });

  return (
    <PromptContext.Provider value={{ deferredPrompt, handleInstallClick }}>
      {children}
    </PromptContext.Provider>
  );
}
